import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import { useSelector } from 'react-redux';
import useSearch from 'src/hooks/useSearch';
import Toolbar from './Toolbar';
import Results from './Results';
import BrandService from '../../../services/BrandService';
import { selector as UserSelector } from '../../../redux/ducks/user';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  brandCard: {
    height: '100%'
  }
}));

const BrandList = () => {
  const classes = useStyles();
  const [brands, setBrands] = useState([]);
  const { user } = useSelector(UserSelector);
  const { dataFilterd, handleSearch, handleInitialData } = useSearch({ keys: ['name'] });

  const getBrands = async () => {
    const fetchData = await BrandService.getAll();

    if (fetchData?.code === 200) {
      setBrands(fetchData.data);
      handleInitialData(fetchData?.data);
    }
  };

  const refresh = async () => {
    if (user?.id) {
      await getBrands();
    }
  };

  useEffect(() => {
    getBrands();
  }, []);

  return (
    <Page
      className={classes.root}
      title="Marcas"
    >
      <Container maxWidth={false}>
        {brands?.length > 0 && <Toolbar refresh={refresh} onSearch={handleSearch} />}
        <Box mt={3}>
          <Results data={dataFilterd} onRefresh={refresh} />
        </Box>
      </Container>
    </Page>
  );
};

export default BrandList;
